import { s3_base_url } from "@/app.config"

export const emojiTypes = [
  "SMILE",
  "LAUGH",
  "OK",
  "THANK_YOU",
  "LOVE",
  "THUMBS_UP",
  "THUMBS_DOWN",
  "I_DONT_KNOW",
  "OH_NO",
  "CRY"
]

export type EmojiType = (typeof emojiTypes)[number]

export const EmojiData = {
  SMILE: {
    src: `${s3_base_url}/static/emojis/SMILE.png`,
    alt: "🙂"
  },
  LAUGH: {
    src: `${s3_base_url}/static/emojis/LAUGH.png`,
    alt: "😆"
  },
  OK: {
    src: `${s3_base_url}/static/emojis/OK.png`,
    alt: "👌"
  },
  THANK_YOU: {
    src: `${s3_base_url}/static/emojis/THANK_YOU.png`,
    alt: "🙏"
  },
  LOVE: {
    src: `${s3_base_url}/static/emojis/LOVE.png`,
    alt: "❤️"
  },
  THUMBS_UP: {
    src: `${s3_base_url}/static/emojis/THUMBS_UP.png`,
    alt: "👍"
  },
  THUMBS_DOWN: {
    src: `${s3_base_url}/static/emojis/THUMBS_DOWN.png`,
    alt: "👎"
  },
  I_DONT_KNOW: {
    src: `${s3_base_url}/static/emojis/I_DONT_KNOW.png`,
    alt: "🤷"
  },
  OH_NO: {
    src: `${s3_base_url}/static/emojis/OH_NO.png`,
    alt: "😱"
  },
  CRY: {
    src: `${s3_base_url}/static/emojis/CRY.png`,
    alt: "😭"
  }
}
